import React from 'react';
import { OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-md border-b-4 border-pf-coralDark bg-pf-coral px-4 py-3 text-center font-display text-[14px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-pf-navy/25 transition-[background-color,transform,border-color] duration-150 ease-out hover:bg-pf-coralDark active:translate-y-1 active:border-b-0 sm:px-6 sm:text-lg ${className}`} data-id="element-47" data-mp="2kzzkh2eklwyl">
      {children}
    </a>;
}